import type { SalaryRole } from '~/composables/useCompanySalaryData'
import { buildCompanyUrl } from '~/utils/formatters'

export default function useRoleUrlFormatter(
  permalink: string,
  selectedState: Ref<string>,
  selectedCity: Ref<string>
) {
  const formatRoleUrl = (role: SalaryRole | null) => {
    if (!role || !role.job_title) return ''

    return buildCompanyUrl(permalink, 'salaries', {
      city: selectedCity.value,
      stateCode: selectedState.value,
      role: role.job_title
    })
  }

  return {
    formatRoleUrl
  }
}
